import { z } from "zod";
import {
  ASSIGN_TO,
  START_DATE,
  END_DATE,
  NAME,
  NOTES,
  PRIORITY,
  ROLE,
  SCHOOL,
  TASK_ATTACHMENT,
  TASK_STATUS,
  TASKS,
  ASSIGNEES,
  TASK_ATTACHMENT_NAME,
} from "../consts";

// Define the base schema without refine first
const baseTaskSchemaCore = z.object({
  [START_DATE]: z.string().min(1, "Start Date is required"),
  [END_DATE]: z.string().min(1, "End Date is required"),
  [TASK_STATUS]: z.string().min(1, "Task Status is required"),
  [TASK_ATTACHMENT]: z.union([z.string(), z.instanceof(File)]).optional(),
  [TASK_ATTACHMENT_NAME]: z.string().optional(),
  [ASSIGNEES]: z
    .array(
      z.object({
        [SCHOOL]: z.string().min(1, "School is required"),
        [ROLE]: z.string().min(1, "Role is required"),
        [ASSIGN_TO]: z.string().min(1, "Assign To is required"),
      })
    )
    .min(1, "At least one assignee is required"),
});

// Extend first (this keeps it a ZodObject)
const newTaskSchema = baseTaskSchemaCore
  .extend({
    [NAME]: z.string().min(3, "Valid Task Name is required"),
    [PRIORITY]: z.string().min(1, "Priority is required"),
    [NOTES]: z
    .string()
    .min(10, "Valid Task Notes are required")
    .max(100, "Task Notes cannot exceed 100 characters"),

  })
  .refine(
    (data) => {
      const start = new Date(data[START_DATE]);
      const end = new Date(data[END_DATE]);
      return !isNaN(start.getTime()) && !isNaN(end.getTime()) && end >= start;
    },
    {
      message: "End Date cannot be earlier than Start Date",
      path: [END_DATE],
    }
  );

const predefinedTaskSchema = baseTaskSchemaCore
  .extend({
    [NAME]: z.string().optional(),
    [PRIORITY]: z.string().optional(),
    [NOTES]: z.string().optional(),
  })
  .refine(
    (data) => {
      const start = new Date(data[START_DATE]);
      const end = new Date(data[END_DATE]);
      return !isNaN(start.getTime()) && !isNaN(end.getTime()) && end >= start;
    },
    {
      message: "End Date cannot be earlier than Start Date",
      path: [END_DATE],
    }
  );

// Main form schema
export const schema = z.object({
  selectedCategory: z.string().optional(),
  [TASKS]: z.array(z.union([newTaskSchema, predefinedTaskSchema])),
});

export type formValues = z.infer<typeof schema>;
